import { PersistState } from 'redux-persist';

export const isPersistedState = (
  state: PersistState | unknown
): state is PersistState =>
  state !== null &&
  typeof state === 'object' &&
  typeof (state as PersistState).version === 'number' &&
  typeof (state as PersistState).rehydrated === 'boolean';
